import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { CurrencyPipe } from "@angular/common";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-pagamento-pedido",
  templateUrl: "./pagamento-pedido.component.html",
  styleUrls: ["./pagamento-pedido.component.css"],
})
export class PagamentoPedidoComponent implements OnChanges {
  @Input() pedido: any;
  @Input() primaryColor = "#6d1b7b";
  @Output() fechar = new EventEmitter<void>();

  public transacao: any = null;
  public metodoPagamento: "cartao" | "pix" | "link" = "link";
  public linkCopiado = false;

  private currencyPipe = new CurrencyPipe("pt-BR");

  constructor(private toastService: ToastrService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.pedido) {
      this.transacao = this.transacaoDoPedido(this.pedido);
      this.metodoPagamento = this.normalizarTipoPagamento(
        this.transacao?.tipo_pagamento
      );
      this.linkCopiado = false;
    }
  }

  fecharPagamento() {
    this.fechar.emit();
  }

  metodoHabilitado(metodo: "cartao" | "pix" | "link"): boolean {
    return this.metodoPagamento === metodo;
  }

  copiarPagamento(texto: string) {
    this.copyLink(texto);
    this.linkCopiado = true;
    setTimeout(() => {
      this.linkCopiado = false;
    }, 2000);
  }

  get numeroPedidoPagando(): string {
    const p = this.pedido;
    return String(p?.numero_pedido || p?.id || "");
  }

  get valorPagamento(): number {
    const valor = this.transacao?.valor;
    if (valor !== null && valor !== undefined && valor !== "") {
      return Number(valor);
    }
    return Number(this.pedido?.total) || 0;
  }

  get linkPagamento(): string {
    return this.transacao?.link_pagamento || "";
  }

  get pixCodigo(): string {
    const qr = this.transacao?.qrcode;
    if (!qr || this.isQrImagem(qr)) {
      return "";
    }
    return String(qr);
  }

  get pixImagem(): string {
    const qr = this.transacao?.qrcode;
    if (!this.isQrImagem(qr)) {
      return "";
    }
    return String(qr).startsWith("data:")
      ? String(qr)
      : "data:image/png;base64," + qr;
  }

  formatValor(valor: number): string {
    return (
      this.currencyPipe.transform(valor, "BRL", "symbol", "1.2-2") || "R$ 0,00"
    );
  }

  private transacaoDoPedido(detalhe: any): any {
    const lista = detalhe?.transacao;
    if (!Array.isArray(lista) || !lista.length) {
      return null;
    }
    return (
      lista.find(
        (t) => String(t?.status || "").toLowerCase() === "pendente"
      ) || lista[0]
    );
  }

  private normalizarTipoPagamento(tipo: any): "cartao" | "pix" | "link" {
    const v = String(tipo || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    if (v.includes("pix")) {
      return "pix";
    }
    if (v.includes("cart") || v.includes("card")) {
      return "cartao";
    }
    return "link";
  }

  private isQrImagem(qr: any): boolean {
    if (!qr || typeof qr !== "string") {
      return false;
    }
    return (
      qr.startsWith("data:image") ||
      (qr.length > 80 && !qr.startsWith("000201") && !qr.startsWith("http"))
    );
  }

  private copyLink(link: string) {
    if (!link) return;
    navigator.clipboard.writeText(link).then(
      () => {
        this.toastService.success(
          $localize`Link copiado com sucesso para a área de transferência`,
          $localize`Pagamento`,
          { positionClass: "toast-bottom-left" }
        );
      },
      () => {
        this.toastService.warning(
          $localize`Erro ao copiar link para a área de transferência`,
          $localize`Pagamento`,
          { positionClass: "toast-bottom-left" }
        );
      }
    );
  }
}
